import { HttpHeaders, HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { environment } from 'src/environments/environment';
import { TokenStorage } from '../core/token-storage';
// const fingerPrint="6DAB6622-BCBA-4FEF-9005-8E66D11CC439"

const baseURL = environment.baseAPIUrl;
const authURL = environment.authAPIURL;
const productConfigURL = environment.productConfigBaseUrl;
const mockProductConfigURL = environment.mockAPIProductConfig;
const coreBaseUrl = environment.coreBaseUrl;

@Injectable({
  providedIn: 'root',
})
export class RestService {
  constructor(public http: HttpClient, private token: TokenStorage) {}

  postData<T>(data: T, url: string): Observable<any> {
    let options = {
      headers: new HttpHeaders({
        // 'fingerprint': `${fingerPrint}`, //-> This is not required -> Commented by Abirami on March 30th
        // "clientInfo": ` {"deviceID":"RFzuSZGSmX0cpYW8PAJb","deviceID2":"RFzuSZGSmX0cpYW8PAJb","deviceTimeZone":"India Standard Time","deviceIpAddress":"103.82.210.58","deviceLatitude":12.686,"deviceLongitude":77.8637,"deviceType":"desktop","deviceModel":"Windows","deviceVersion":"windows-10","deviceUserID":"Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/113.0.0.0 Safari/537.36 Edg/113.0.1774.35","deviceAppVersion":"1.0.8","deviceIsJailBroken":false,"language":"en"}`,
        // "Authorization": `Bearer  ${x}`,
        orgAppID: environment.orgAppId.toString(),
        orgGroupID: environment.orgGroupID.toString(),
      }),
    };
    if (url.startsWith('https://')) {
      return this.http.post<any>(url, data, options).pipe(
        map((response) => {
          if (response.rcode == 500) {
            return null;
          }
          return response;
        })
      );
    } else {
      return this.http.post<any>(`${baseURL}` + url, data, options).pipe(
        map((response) => {
          if (response.rcode == 500) {
            return null;
          }
          return response;
        })
      );
    }
  }
  postUATData<T>(data: T, url: string): Observable<any> {
    let options = {
      headers: new HttpHeaders({
        // 'fingerprint': `${fingerPrint}`, //-> This is not required -> Commented by Abirami on March 30th
        // "clientInfo": ` {"deviceID":"RFzuSZGSmX0cpYW8PAJb","deviceID2":"RFzuSZGSmX0cpYW8PAJb","deviceTimeZone":"India Standard Time","deviceIpAddress":"103.82.210.58","deviceLatitude":12.686,"deviceLongitude":77.8637,"deviceType":"desktop","deviceModel":"Windows","deviceVersion":"windows-10","deviceUserID":"Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/113.0.0.0 Safari/537.36 Edg/113.0.1774.35","deviceAppVersion":"1.0.8","deviceIsJailBroken":false,"language":"en"}`,
        // "Authorization": `Bearer  ${x}`,
        orgAppID: environment.orgAppId.toString(),
        orgGroupID: environment.orgGroupID.toString(),
      }),
    };
    if (url.startsWith('https://')) {
      return this.http.post<any>(url, data, options).pipe(
        map((response) => {
          if (response.rcode == 500) {
            return null;
          }
          return response;
        })
      );
    } else {
      return this.http.post<any>(`${authURL}` + url, data, options).pipe(
        map((response) => {
          if (response.rcode == 500) {
            return null;
          }
          return response;
        })
      );
    }
  }
  postUATAuthData<T>(data: T, url: string): Observable<any> {
    let options = {
      headers: new HttpHeaders({ }),
    };
    if (url.startsWith('https://')) {
      return this.http.post<any>(url, data, options).pipe(
        map((response) => {
          if (response.rcode == 500) {
            return null;
          }
          return response;
        })
      );
    } else {
      return this.http.post<any>(`${authURL}` + url, data, options).pipe(
        map((response) => {
          if (response.rcode == 500) {
            return null;
          }
          return response;
        })
      );
    }
  }
  postProductConfigData<T>(
    data: T,
    url: string  ): Observable<any> {
    let options = {
      headers: new HttpHeaders({
        // 'fingerprint': `${fingerPrint}`, //-> This is not required -> Commented by Abirami on March 30th
        // "clientInfo": ` {"deviceID":"RFzuSZGSmX0cpYW8PAJb","deviceID2":"RFzuSZGSmX0cpYW8PAJb","deviceTimeZone":"India Standard Time","deviceIpAddress":"103.82.210.58","deviceLatitude":12.686,"deviceLongitude":77.8637,"deviceType":"desktop","deviceModel":"Windows","deviceVersion":"windows-10","deviceUserID":"Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/113.0.0.0 Safari/537.36 Edg/113.0.1774.35","deviceAppVersion":"1.0.8","deviceIsJailBroken":false,"language":"en"}`,
        // "Authorization": `Bearer  ${x}`,
        orgAppID: environment.orgAppId.toString(),
        orgGroupID: environment.orgGroupID.toString(),
      }),
    };
    if (url.startsWith('https://')) {
      return this.http.post<any>(url, data, options).pipe(
        map((response) => {
          if (response.rcode == 500) {
            return null;
          }
          return response;
        })
      );
    } else {
      return this.http
        .post<any>(`${productConfigURL}` + url, data, options)
        .pipe(
          map((response) => {
            if (response.rcode == 500) {
              return null;
            }
            return response;
          })
        );
    }
  }
  postMockProductConfigData<T>(
    data: T,
    url: string  ): Observable<any> {
    if (url.startsWith('https://')) {
      return this.http.post<any>(url, data).pipe(
        map((response) => {
          if (response.rcode == 500) {
            return null;
          }
          return response;
        })
      );
    } else {
      return this.http.post<any>(`${mockProductConfigURL}` + url, data).pipe(
        map((response) => {
          if (response.rcode == 500) {
            return null;
          }
          return response;
        })
      );
    }
  }
  postCoreBaseData<T>(
    data: T,
    url: string ,
    customHeaders?: HttpHeaders ): Observable<any> {
    // let orgGroupId = this.getOrgGroupId();
    let headers = customHeaders ?? new HttpHeaders();
    let options = { headers };
    // let options = {
    //   headers: new HttpHeaders({

    //     //'fingerprint': `"RFzuSZGSmX0cpYW8PAJb", `,//-> This is not required -> Commented by Abirami on March 30th
    //     // "clientInfo": ` {"deviceID":"RFzuSZGSmX0cpYW8PAJb","deviceID2":"RFzuSZGSmX0cpYW8PAJb","deviceTimeZone":"India Standard Time","deviceIpAddress":"103.82.210.58","deviceLatitude":12.686,"deviceLongitude":77.8637,"deviceType":"desktop","deviceModel":"Windows","deviceVersion":"windows-10","deviceUserID":"Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/113.0.0.0 Safari/537.36 Edg/113.0.1774.35","deviceAppVersion":"1.0.8","deviceIsJailBroken":false,"language":"en"}`,
    //     // "Authorization": `Bearer  ${x}`,
    //     // orgAppID: this.domain.includes('cholams-primez.insure.digital') || this.domain.includes("zuno-primez.insure.digital") ? "6160" : this.orgAppId?.toString() ?? '',
    //     // ...(orgGroupId ? { orgGroupId: orgGroupId } : {})
    //   }),
    // };
    if (url.startsWith('https://')) {
      return this.http.post<any>(url, data, options).pipe(
        map((response) => {
          if (response.rcode == 500) {
            return null;
          }
          return response;
        })
      );
    } else {
      return this.http
        .post<any>(`${coreBaseUrl}` + url, data, options)
        .pipe(
          map((response) => {
            if (response.rcode == 500) {
              return null;
            }
            return response;
          })
        );
    }
  }
  fetchData<T>(
    graphqlPayload: T,
    url: string,
    additionalheaders: any
  ): Observable<any> {
    const options = {
      headers: new HttpHeaders({
        // 'fingerprint': `${fingerPrint}`, //-> This is not required -> Commented by Abirami on March 30th

        Reportid: additionalheaders.reportID.toLowerCase(),
        Filters: JSON.stringify(additionalheaders.filters),
        'Content-Type': 'application/json',
        orgGroupID: environment.orgGroupID.toString(),
      }),
    };
    return this.http
      .post<any>(`${baseURL}${url}`, graphqlPayload, options)
      .pipe(
        map((response) => {
          // Your additional processing logic goes here
          return response;
        })
      );
  }
  fetchDataUAD<T>(
    graphqlPayload: T,
    url: string,
    additionalheaders: any
  ): Observable<any> {
    const options = {
      headers: new HttpHeaders({
        // 'fingerprint': `${fingerPrint}`,
        Reportid: additionalheaders.reportID.toLowerCase(),
        Filters: JSON.stringify(additionalheaders.filters),
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .post<any>(`${authURL}${url}`, graphqlPayload, options)
      .pipe(
        map((response) => {
          // Your additional processing logic goes here
          return response;
        })
      );
  }
  postCustomData<T>(data: T, url: string): Observable<any> {
    let tk = this.token.get();
    let lang = '';
    let userSettings = window.localStorage.getItem('userSettings');
    if (userSettings) {
      let userSettingParsed = JSON.parse(userSettings);
      lang = userSettingParsed.lang;
    } else {
      lang = 'en';
    }
    let options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',

      //   "clientInfo": `{"deviceID": "RFzuSZGSmX0cpYW8PAJb","deviceID2": "RFzuSZGSmX0cpYW8PAJb",
      //  "deviceTimeZone": "India Standard Time",
      //  "deviceIpAddress": "103.82.210.58",
      //  "deviceLatitude": 12.686,
      //  "deviceLongitude": 77.8637,
      //  "deviceType": "desktop",
      //  "deviceModel": "Windows",
      //  "deviceVersion": "windows-10",
      //  "deviceUserID": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/113.0.0.0 Safari/537.36 Edg/113.0.1774.35",
      //  "deviceAppVersion": "1.0.8",
      //  "deviceIsJailBroken": false,
      //  "language": ${lang}}`,
        Authorization: `Bearer  ${tk}`,
        orgAppID: environment.orgAppId.toString(),
      }),
    };
    // console.log(options, 'headerss');

    if (url.startsWith('https://')) {
      return this.http.post<any>(url, data, options).pipe(
        map((response) => {
          if (response.rcode == 500) {
            return null;
          }
          return response;
        })
      );
    } else {
      return this.http
        .post<any>(`${productConfigURL}` + url, data, options)
        .pipe(
          map((response) => {
            if (response.rcode == 500) {
              return null;
            }
            return response;
          })
        );
    }
  }
  getData<T>(url: string, isFullURL?: boolean): Observable<T> {
    return this.http.get<T>(isFullURL ? `${url}` : `${baseURL}${url}`);
  }
  getDataMethod(url: string, params?: HttpParams): Observable<any> {
    return this.http.get<any>(url, { params }).pipe(
      map((response) => {
        return response;
      })
    );
  }
  public getPhoneCode(): Observable<any> {
    return this.http.get('./assets/jsons/phoneCode.json');
  }
  public getComparsionJson(): Observable<any> {
    return this.http.get('./assets/comparsion.json');
  }
  public getcomprehensiveJson(): Observable<any> {
    return this.http.get('./assets/comprehensive.json');
  }
  public getTPTFJson(): Observable<any> {
    return this.http.get('./assets/TPTF.json');
  }
  public getTPOJson(): Observable<any> {
    return this.http.get('./assets/TPO.json');
  }
  getUIConfig(): Observable<any[]> {
    return this.http.get<any[]>('assets/jsons/org-ui-config.json');
  }

  getUIConfigByOrgAppID(orgAppID: number): Observable<any | null> {
    return this.getUIConfig().pipe(
      map(configs => configs.find(c => c.orgAppID === orgAppID) || null)
    );
  }
  getUIConfigByOrgKey(orgKey: string): Observable<any> {
    return this.getUIConfig().pipe(
      map(configs => configs.find(c => c.orgKey === orgKey))
    );
  }
}
